import type { MarketTechnicals } from '../models/MarketValuationTypes';

export function mapMarketTechnicals(raw?: Record<string, unknown> | null): MarketTechnicals | undefined {
  if (!raw) return undefined;
  return {
    rsi: raw.rsi != null ? Number(raw.rsi) : null,
    rsiSignal: (raw.rsiSignal as string) ?? null,
    recommendAll: raw.recommendAll != null ? Number(raw.recommendAll) : null,
    recommendAllLabel: (raw.recommendAllLabel as string) ?? null,
    recommendMa: raw.recommendMa != null ? Number(raw.recommendMa) : null,
    recommendMaLabel: (raw.recommendMaLabel as string) ?? null,
    recommendOther: raw.recommendOther != null ? Number(raw.recommendOther) : null,
    recommendOtherLabel: (raw.recommendOtherLabel as string) ?? null,
    adx: raw.adx != null ? Number(raw.adx) : null,
    trendStrength: (raw.trendStrength as string) ?? null,
    macd: raw.macd != null ? Number(raw.macd) : null,
    macdSignal: raw.macdSignal != null ? Number(raw.macdSignal) : null,
    macdSignalLabel: (raw.macdSignalLabel as string) ?? null,
    sma20: raw.sma20 != null ? Number(raw.sma20) : null,
    sma50: raw.sma50 != null ? Number(raw.sma50) : null,
    sma200: raw.sma200 != null ? Number(raw.sma200) : null,
    ema20: raw.ema20 != null ? Number(raw.ema20) : null,
    ema50: raw.ema50 != null ? Number(raw.ema50) : null,
    stochK: raw.stochK != null ? Number(raw.stochK) : null,
    stochD: raw.stochD != null ? Number(raw.stochD) : null,
    stochSignal: (raw.stochSignal as string) ?? null,
    pivotClassicMiddle: raw.pivotClassicMiddle != null ? Number(raw.pivotClassicMiddle) : null,
    pivotClassicR1: raw.pivotClassicR1 != null ? Number(raw.pivotClassicR1) : null,
    pivotClassicS1: raw.pivotClassicS1 != null ? Number(raw.pivotClassicS1) : null,
    priceVsSma20: (raw.priceVsSma20 as string) ?? null,
    priceVsSma50: (raw.priceVsSma50 as string) ?? null,
  };
}
